import { useQuestionEditorContext } from 'components/Questionsv2/builder/context/create-question.context';
import AddRuleDropdownFields from 'components/Rules/AddRuleDropdown';
import { supportsAnswerCondition } from 'components/Rules/helpers/ruleUpdates';
import { upsertQuestionRule } from 'rtk/Question.Editor.Slice';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import { selectQuestionIsReadonly, selectQuestionType } from 'rtk/questionEditorSelector';
import { ruleType1, ruleType2 } from 'types/rules.types';

const AddRuleDropdown = () => {
  const { questionId } = useQuestionEditorContext();
  const dispatch = useAppDispatch();
  const isReadOnly = useAppSelector((state) => selectQuestionIsReadonly(state, questionId));
  const type = useAppSelector((state) => selectQuestionType(state, questionId));

  return (
    <AddRuleDropdownFields
      isReadOnly={isReadOnly}
      hideDoIf={!supportsAnswerCondition(type)}
      onAddDoIf={() => dispatch(upsertQuestionRule({ questionId, rule: ruleType1() }))}
      onAddShowIf={() => dispatch(upsertQuestionRule({ questionId, rule: ruleType2() }))}
    />
  );
};

export default AddRuleDropdown;
